import React, { FC } from 'react';
import { GetCategoryQuery } from '../__generated__/graphql';
import { Unpacked } from '../graphQLTypes/types';
import { useModal } from '../dialogs/useModal';
import { CategoryCommentDialog, CategoryCommentDialogInput } from './CategoryCommentDialog';
import { CommentsCard } from '../comments/CommentsCard';
import { useCategoryCommentActions } from './useCategoryCommentActions';

type Comment = Unpacked<NonNullable<GetCategoryQuery['category']>['comments']>;

/** Comments on a Fagområde: editors' internal notes and customer feedback from the portal, as on a guide page. */
export const Comments: FC<{ categoryId: string; comments: Comment[]; onUpdate: () => Promise<unknown> }> = ({ categoryId, comments, onUpdate }) => {
  const commentDialog = useModal<CategoryCommentDialogInput, boolean>({ data: { categoryId } });
  const actions = useCategoryCommentActions();

  const add = async () => {
    const result = await commentDialog.open({ categoryId });
    if (result) {
      await onUpdate();
    }
  };

  return (
    <CommentsCard comments={comments.filter((c): c is NonNullable<Comment> => !!c)} actions={actions} onAdd={add}>
      {commentDialog.isOpen && <CategoryCommentDialog modal={commentDialog} />}
    </CommentsCard>
  );
};
